import { recordLastAnalyticsEvent } from './capture';
import { ANALYTICS_APP_TYPE_FOR_SENTRY } from './constant';

/** Map analytics app codes to the prefix used in PostHog / flows */
export const normalizeAppTypeForSentry = (appType?: string): string =>
  ANALYTICS_APP_TYPE_FOR_SENTRY[appType?.toUpperCase() ?? ''] ?? 'PG';

export const formatSentryAnalyticsEvent = (
  eventName: string,
  appType = 'PG',
): string => {
  const trimmed = eventName?.trim();
  if (!trimmed) return '';
  if (trimmed.includes('>')) return trimmed;
  return `${normalizeAppTypeForSentry(appType)}:> ${trimmed}`;
};

export const touchSentryAnalyticsEvent = (
  eventName: string,
  appType = 'PG',
): void => {
  const key = formatSentryAnalyticsEvent(eventName, appType);
  if (key) recordLastAnalyticsEvent(key);
};
